import axios from '@/utils/request';

// 获取直播列表
export const getLiveActivities = (data: any) => {
  return axios.request({
    url: 'LiveActivity/GetLiveActivities',
    method: 'GET',
    params: data,
  });
};

// 获取我的直播列表
export const getMyLiveActivities = (data: any) => {
  return axios.request({
    url: 'LiveActivity/getMyLiveActivities',
    method: 'GET',
    params: data,
  });
};

// 获取直播详情
export const getLiveDetails = (data: any) => {
  return axios.request({
    url: 'LiveActivity/GetLiveDetails',
    method: 'GET',
    params: data,
  });
};

// 开启直播
export const startLive = (data: any) => {
  return axios.request({
    url: 'LiveActivity/StartLive',
    method: 'GET',
    params: data,
  });
};

// 更新直播状态
export const updateLiveState = (data: any) => {
  return axios.request({
    url: 'LiveActivity/UpdateLiveState',
    method: 'POST',
    data,
  });
};

// 预约直播
export const subLive = (data: any) => {
  return axios.request({
    url: 'LiveActivity/SubLive',
    method: 'POST',
    params: data,
  });
};
